import React from 'react'
import 'Loader/loader.css';
function loader() {
    return (
        <div id='loadd'>
            <div id='loa'>
             <div className="uil-reload-css reload-background mr-1">
             <div />
            </div>
            </div>
             
        </div>
    )
}
export default loader;